import { FilterAccess, FilterOfficeMode } from './userGroupFilterTypes';

export const filterAccessDefault: FilterAccess = {
  noUsers: false,
  noSchedule: false,
  noDevices: false
};

export const filterOfficeModeDefault: FilterOfficeMode = null;
